import { apiRemote } from './RemoteService';

export const MERGE_TAG_TYPES = {
  DEFAULT: 'default',
  PROSPECT: 'prospect',
  RESIDENT: 'resident',
};

export const getEmailMergeTags = () => apiRemote.get('chats-batch/merge-tags');
